import { atom } from "recoil";

export type IFilterTabStatus = "all" | "pending" | "underReview" | "rejected" | "completed" | "amlWarning";

export const SelectedFilterTabState = atom<IFilterTabStatus>({
	key: 'selected-filter-tab-key',
	default: "all",
});
